<div class="article">
    <h3 class="article__heading"
        [innerHTML]="article?.name"></h3>
    <div [innerHTML]="article?.body"></div>
</div>